import { all } from 'redux-saga/effects';
import { indicatorSaga } from './IndicatorSaga';
import { providerSearchSaga } from './ProviderSearchSaga';
import { siteOfServiceSaga } from './SiteOfServiceSaga';
import { valueBasedContractingSaga } from './ValueBasedContractingSaga';
import { affordabilitySaga } from './affordabilityServiceSaga';
import { pnsStrategySaga } from './pnbSaga/pnsStrategySaga';
import { providerExperienceFiltersSaga } from './provider-experience-filters-saga';
import { reimbursementSaga } from './reimbursement/reimbursementSaga';
//import { overPaymentSaga } from './reimbursement/overPaymentSaga/overPaymentSaga';
import { ImagingSaga } from './Ancillary/imagingSaga';
import { LabsSaga } from './Ancillary/labsSaga';
import { hiVolumeTinsSaga } from './HiVolumeTinsSaga';
import { notificationBannerSaga } from './NotificationBannerSaga';
import { priorAuthSaga } from './PriorAuthSaga';
import { callPageSaga } from './callPageSaga';
import { exemptionSaga } from './exemption-saga';
import { faqSaga } from './faqSaga';
import { globalFilterSaga } from './globalFilterSaga';
import { myInsightsSaga } from './my-insights-saga';
import { onBoardingSaga } from './onBoarding-saga';
import { overviewSaga } from './overview-saga';
import { pcorSaga } from './pcorSaga';
import { providerExperienceSaga } from './provider-experience-saga';
import { pemDetailsSaga } from './PEM/pem-details-saga';
import { psmsSaga } from './psms/psmsSaga';
import { claimsProcessedSaga } from './reimbursement/claimsProcessedSaga/claimsProcessedSaga';
import { reconsiderSaga } from './reimbursement/reconsiderationSaga/reconsiderationSaga';
import { ediFilterSaga } from './serviceInteraction/digitalSummary/ediFilterSaga/ediFilterSaga';
import { PreCheckMyScriptSaga } from './serviceInteraction/digitalSummary/preCheckMyScriptSaga/preCheckMyScriptSaga';
import { smartEditGeoFilterSaga } from './serviceInteraction/digitalSummary/smartEditGeoFilterSaga/smartEditGeoFilterSaga';
import { smartEditsSaga } from './serviceInteraction/digitalSummary/smartEditsSaga/smartEditsSaga';
import { surestSaga } from './surestSaga';
import { advanceSearchSaga } from './AdvanceSearch/AdvanceSearchSaga';
import { impactSaga } from './impactSaga';
import { claimsReportingSaga } from './claimsReportingSaga';
import { pemSummarySaga } from './PEM/pem-summary-saga';
import croSaga from '@src/apps/NetworkManagement/ContractRemediationOpportunities/croSaga';

export default function* rootSaga() {
  yield all([
    siteOfServiceSaga(),
    indicatorSaga(),
    affordabilitySaga(),
    valueBasedContractingSaga(),
    providerSearchSaga(),
    pnsStrategySaga(),
    reimbursementSaga(),
    providerExperienceFiltersSaga(),
    //overPaymentSaga(),
    globalFilterSaga(),
    providerExperienceSaga(),
    pemDetailsSaga(),
    priorAuthSaga(),
    hiVolumeTinsSaga(),
    exemptionSaga(),
    reconsiderSaga(),
    claimsProcessedSaga(),
    surestSaga(),
    smartEditsSaga(),
    pcorSaga(),
    notificationBannerSaga(),
    LabsSaga(),
    ImagingSaga(),
    callPageSaga(),
    onBoardingSaga(),
    myInsightsSaga(),
    PreCheckMyScriptSaga(),
    overviewSaga(),
    ediFilterSaga(),
    faqSaga(),
    smartEditGeoFilterSaga(),
    psmsSaga(),
    advanceSearchSaga(),
    impactSaga(),
    claimsReportingSaga(),
    pemSummarySaga(),
    croSaga(),
  ]);
}
